import { DicomRegistry } from 'app/interfaces/DicomRegistry';
import { Role, FindQueryModel, GetQueryModel } from 'app/interfaces/PACSCommunication';

export const ABSTRACT_SYNTAXES_WITH_ROLE = [
  [DicomRegistry.ComputedRadiographyImageStorage, Role.SCP] as const,
  [DicomRegistry.Verification, Role.SCU] as const,
  [FindQueryModel.Patient, Role.SCU] as const,
  [FindQueryModel.Study, Role.SCU] as const,
  [FindQueryModel.Worklist, Role.SCU] as const,
  [GetQueryModel.Study, Role.SCU] as const,
] as const;
type ABSTRACT_SYNTAXES_WITH_ROLE_LENGTH = typeof ABSTRACT_SYNTAXES_WITH_ROLE['length'];
